import type { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, use } from "react";

import { CardVariantsProps } from "../card.props";

type CardContextValue = CardVariantsProps;

type CardContextProviderProps = RequireChildrenFor<CardVariantsProps>;

export const CardContext = createContext<CardContextValue | undefined>(
    undefined
);
CardContext.displayName = "CardContext";

export const CardContextProvider = ({
    children,
    ...props
}: CardContextProviderProps) => {
    return <CardContext value={{ ...props }}>{children}</CardContext>;
};

export const useCardContext = () => {
    const context = use<CardContextValue | undefined>(CardContext);

    if (!isDefined(context)) {
        throw new Error(`${CardContext.displayName} is undefined.`);
    }

    return context;
};
